import { jsx as s, jsxs as m } from "react/jsx-runtime";
import r from "classnames";
import "./main.scss";
import { SpinnerSize as n, Intent as e, Spinner as N } from "@blueprintjs/core";
const b = ({ inline: a = !1 }) => /* @__PURE__ */ s("div", { className: "sds_loading-container", role: "progressbar", "aria-label": "loading", children: /* @__PURE__ */ m("div", { className: r("sds_bars-container", { "sds_bars-container--fixed": !a }), children: [
  /* @__PURE__ */ s("div", { className: "sds_bar sds_bar-one" }),
  /* @__PURE__ */ s("div", { className: "sds_bar sds_bar-two" }),
  /* @__PURE__ */ s("div", { className: "sds_bar sds_bar-three" })
] }) }), i = {
  SMALL: n.SMALL,
  STANDARD: n.STANDARD,
  LARGE: n.LARGE
}, o = {
  NONE: e.NONE,
  PRIMARY: e.PRIMARY
}, d = ({
  size: a = i.STANDARD,
  intent: t = o.PRIMARY,
  value: c = void 0,
  className: l = void 0
}) => /* @__PURE__ */ s(
  N,
  {
    size: a,
    intent: t,
    value: c,
    className: r("sds_spinner", l)
  }
);
d.Size = i;
d.Intent = o;
export {
  b as Loading,
  d as Spinner
};
//# sourceMappingURL=index.js.map
